import { store } from '@chilipiper/utils'
import { abortError, onAbort } from './abort'

const TIMEOUT_ERROR_STRING = 'Timeout waiting for localStorage key'

// store auto-parses JSON-encoded values on get — external scripts commonly write their
// values as JSON.stringify(...), so callers receive the decoded value directly.
export const waitForLocalStorage = (
  key: string,
  {
    interval = 200,
    timeout = 10_000,
    signal,
  }: {
    interval?: number
    timeout?: number
    // Aborting stops the polling and rejects with the abort error.
    signal?: AbortSignal
  } = {}
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    const start = Date.now()
    let stopListening = (): void => {}

    const timer = setInterval(() => {
      const value: unknown = store.get(key)

      if (value !== null) {
        finish()
        resolve(value)
      } else if (Date.now() - start >= timeout) {
        finish()
        reject(new Error(TIMEOUT_ERROR_STRING))
      }
    }, interval)

    const finish = (): void => {
      clearInterval(timer)
      stopListening()
    }

    stopListening = onAbort(signal, () => {
      finish()
      reject(abortError())
    })
  })
}
